import { Brand as BrandType, Integration } from 'data/types/brand';
import { normalizeScheduleWeek } from 'model/schedule';
import { parseISO } from 'date-fns';

export const normalizeIntegration = (data: Integration) => {
  return {
    id: data.id,
    name: {
      short: data.name.short,
      full: data.name.full,
    },
    image: {
      src: data.icon.small,
      alt: `${data.name.full} logo`,
    },
    isExpected: data.isExpected,
    isActive: data.isActive,
    disabled: data.disabled,
    closureReason: data.closureReason,
    isBusy: data.isBusy,
    busyUntil: data.busyUntil != null ? parseISO(data.busyUntil) : null,
  };
};

export const normalizeBrand = (data: BrandType) => {
  return {
    id: data.id,
    timezone: data.timezone,
    name: data.name,
    image: {
      src: data.icon,
      alt: `${data.name} logo`,
    },
    timings: normalizeScheduleWeek(data.timings),
    integrations: data.integrations.map(normalizeIntegration),
    features: data.features,
  };
};

export type BrandIntegration = ReturnType<typeof normalizeIntegration>;
export type Brand = ReturnType<typeof normalizeBrand>;
